import { render } from "./ForbiddenView.vue?vue&type=template&id=cd12ec90&scoped=true"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"

import "./ForbiddenView.vue?vue&type=style&index=0&id=cd12ec90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd12ec90"]])

export default __exports__